export const BOOK_RECIPES = [
  {
    id: 'book-mme-mediterranean-power-bowl',
    name: 'Classic Mediterranean Power Bowl',
    category: 'Lunch',
    description: 'A balanced chicken, quinoa, veggie, and feta bowl from Macros Made Easy for Women.',
    servings: 1,
    prep_time: '10 mins',
    cook_time: '15 mins',
    calories: 415,
    protein: 32,
    carbs: 28,
    fat: 18,
    fiber: 5,
    ingredients: ['4 oz cooked chicken breast', '1/2 cup cooked quinoa', 'Cucumber, tomato, and greens', '1 tbsp feta', '1 tbsp tzatziki or Greek yogurt sauce', 'Lemon juice and oregano'],
    instructions: ['Cook or warm the chicken and quinoa.', 'Layer greens, vegetables, quinoa, and chicken in a bowl.', 'Top with feta, sauce, lemon, and oregano.'],
    tags: ['book-recipe', 'lunch', 'high-protein'],
  },
  {
    id: 'book-mme-turkey-avocado-collard-wrap',
    name: 'Turkey & Avocado Collard Wrap',
    category: 'Lunch',
    description: 'A no-cook wrap for busy days when you need protein fast.',
    servings: 1,
    prep_time: '5 mins',
    cook_time: '0 mins',
    calories: 280,
    protein: 25,
    carbs: 12,
    fat: 15,
    fiber: 6,
    ingredients: ['2 large collard leaves', '4 oz sliced turkey breast', '1/4 avocado', 'Tomato slices', 'Cucumber strips', 'Mustard or Greek yogurt spread'],
    instructions: ['Trim the thick stem from each collard leaf.', 'Layer turkey, avocado, tomato, cucumber, and spread.', 'Roll tightly like a burrito and slice in half.'],
    tags: ['book-recipe', 'lunch', 'no-cook'],
  },
  {
    id: 'book-mme-taco-salad-jar',
    name: '10-Minute Taco Salad Jar',
    category: 'Lunch',
    description: 'A portable taco salad layered to stay crisp until lunch.',
    servings: 1,
    prep_time: '10 mins',
    cook_time: '0 mins',
    calories: 390,
    protein: 36,
    carbs: 25,
    fat: 16,
    fiber: 7,
    ingredients: ['4 oz cooked seasoned ground turkey or beef', '1/2 cup black beans', '1/4 cup corn', 'Romaine lettuce', 'Salsa', 'Greek yogurt or light sour cream', 'Shredded cheese'],
    instructions: ['Add salsa and yogurt to the bottom of a jar.', 'Layer beans, corn, cooked meat, cheese, and lettuce.', 'Shake into a bowl when ready to eat.'],
    tags: ['book-recipe', 'lunch', 'meal-prep'],
  },
  {
    id: 'book-mme-asian-peanut-noodle-bowl',
    name: 'Speedy Asian Peanut Noodle Bowl',
    category: 'Lunch',
    description: 'A quick noodle bowl with protein, vegetables, and peanut sauce.',
    servings: 1,
    prep_time: '10 mins',
    cook_time: '5 mins',
    calories: 430,
    protein: 30,
    carbs: 45,
    fat: 15,
    fiber: 6,
    ingredients: ['3 oz cooked shrimp, chicken, or tofu', 'Cooked noodles', 'Shredded cabbage', 'Carrot ribbons', 'Edamame', 'Peanut sauce'],
    instructions: ['Cook noodles and rinse under cool water.', 'Whisk peanut sauce with a splash of warm water if needed.', 'Toss noodles, protein, vegetables, edamame, and sauce together.'],
    tags: ['book-recipe', 'lunch', 'quick'],
  },
  {
    id: 'book-mme-lentil-spinach-soup',
    name: 'Hearty Lentil & Spinach Soup',
    category: 'Lunch',
    description: 'A high-fiber soup that works well for meal prep.',
    servings: 4,
    prep_time: '10 mins',
    cook_time: '20 mins',
    calories: 310,
    protein: 20,
    carbs: 45,
    fat: 4,
    fiber: 12,
    ingredients: ['Lentils', 'Spinach', 'Carrots', 'Celery', 'Onion', 'Garlic', 'Vegetable or chicken broth', 'Italian seasoning'],
    instructions: ['Saute onion, carrots, celery, and garlic.', 'Add lentils, broth, and seasoning, then simmer until tender.', 'Stir in spinach at the end and season to taste.'],
    tags: ['book-recipe', 'lunch', 'meal-prep', 'high-fiber'],
  },
  {
    id: 'book-mme-greek-yogurt-chicken-salad-pita',
    name: 'Greek Yogurt Chicken Salad Stuffed Pita',
    category: 'Lunch',
    description: 'A lighter chicken salad with a strong protein payoff.',
    servings: 1,
    prep_time: '10 mins',
    cook_time: '0 mins',
    calories: 340,
    protein: 38,
    carbs: 28,
    fat: 7,
    fiber: 3,
    ingredients: ['4 oz cooked chicken breast', 'Plain Greek yogurt', 'Celery', 'Red grapes or apple', 'Dijon mustard', 'Whole-wheat pita', 'Lettuce'],
    instructions: ['Mix chicken, yogurt, celery, fruit, and mustard.', 'Season with salt and pepper.', 'Stuff into pita with lettuce right before eating.'],
    tags: ['book-recipe', 'lunch', 'high-protein'],
  },
  {
    id: 'book-mme-black-bean-corn-quesadilla',
    name: 'Black Bean & Corn Quesadilla',
    category: 'Lunch',
    description: 'A crispy, fiber-rich vegetarian lunch option.',
    servings: 1,
    prep_time: '5 mins',
    cook_time: '5 mins',
    calories: 380,
    protein: 22,
    carbs: 50,
    fat: 11,
    fiber: 10,
    ingredients: ['Whole-wheat tortilla', '1/2 cup black beans', 'Corn', 'Shredded cheese', 'Salsa', 'Spinach or peppers'],
    instructions: ['Fill tortilla with beans, corn, cheese, and vegetables.', 'Fold and cook in a nonstick skillet until golden on both sides.', 'Serve with salsa.'],
    tags: ['book-recipe', 'lunch', 'vegetarian'],
  },
  {
    id: 'book-mme-cottage-cheese-tuna-tomatoes',
    name: 'Cottage Cheese Tuna Salad Stuffed Tomatoes',
    category: 'Lunch',
    description: 'A fresh, no-cook lunch with very high protein.',
    servings: 1,
    prep_time: '10 mins',
    cook_time: '0 mins',
    calories: 250,
    protein: 38,
    carbs: 12,
    fat: 4,
    fiber: 3,
    ingredients: ['1 can tuna', '1/4 cup cottage cheese', 'Diced celery', 'Dijon mustard', 'Large tomatoes', 'Lemon juice', 'Pepper'],
    instructions: ['Mix tuna, cottage cheese, celery, mustard, lemon, and pepper.', 'Hollow tomatoes slightly.', 'Spoon tuna salad into tomatoes.'],
    tags: ['book-recipe', 'lunch', 'no-cook', 'high-protein'],
  },
  {
    id: 'book-mme-loaded-chicken-veggie-quesadillas',
    name: 'Loaded Chicken & Veggie Quesadillas',
    category: 'Dinner',
    description: 'A simple weeknight dinner using shredded chicken and vegetables.',
    servings: 4,
    prep_time: '10 mins',
    cook_time: '10 mins',
    calories: 350,
    protein: 28,
    carbs: 28,
    fat: 12,
    fiber: 5,
    ingredients: ['2 cups shredded cooked chicken', 'Whole-wheat tortillas', 'Bell peppers', 'Spinach', 'Shredded cheese', 'Salsa', 'Cooking spray'],
    instructions: ['Fill tortillas with chicken, vegetables, cheese, and salsa.', 'Cook in a nonstick skillet until golden and melted.', 'Slice and serve with extra salsa.'],
    tags: ['book-recipe', 'dinner', 'easy'],
  },
  {
    id: 'book-mme-lemon-herb-chicken-roasted-veggies',
    name: 'Lemon-Herb Chicken & Roasted Veggies',
    category: 'Dinner',
    description: 'A sheet-pan chicken dinner with simple herbs and vegetables.',
    servings: 4,
    prep_time: '10 mins',
    cook_time: '25 mins',
    calories: 340,
    protein: 35,
    carbs: 15,
    fat: 14,
    fiber: 5,
    ingredients: ['Chicken breast cubes', 'Broccoli', 'Bell peppers', 'Zucchini', 'Olive oil', 'Lemon juice', 'Oregano and thyme'],
    instructions: ['Toss chicken and vegetables with olive oil, lemon, and herbs.', 'Spread on a sheet pan.', 'Roast until chicken reaches 165 F and vegetables are tender.'],
    tags: ['book-recipe', 'dinner', 'sheet-pan'],
  },
  {
    id: 'book-mme-salmon-asparagus-tomatoes',
    name: 'Sheet Pan Salmon & Asparagus with Cherry Tomatoes',
    category: 'Dinner',
    description: 'A fast salmon dinner with colorful vegetables.',
    servings: 4,
    prep_time: '8 mins',
    cook_time: '15 mins',
    calories: 380,
    protein: 32,
    carbs: 8,
    fat: 24,
    fiber: 3,
    ingredients: ['Salmon fillets', 'Asparagus', 'Cherry tomatoes', 'Olive oil', 'Lemon', 'Dill or parsley', 'Garlic'],
    instructions: ['Place salmon and vegetables on a lined sheet pan.', 'Season with olive oil, lemon, herbs, garlic, salt, and pepper.', 'Bake until salmon flakes easily.'],
    tags: ['book-recipe', 'dinner', 'sheet-pan'],
  },
  {
    id: 'book-mme-maple-balsamic-tofu-sweet-potato',
    name: 'Maple-Balsamic Tofu & Sweet Potato Sheet Pan',
    category: 'Dinner',
    description: 'A plant-based sheet-pan meal with sweet potatoes and tofu.',
    servings: 4,
    prep_time: '10 mins',
    cook_time: '30 mins',
    calories: 320,
    protein: 16,
    carbs: 32,
    fat: 15,
    fiber: 7,
    ingredients: ['Extra-firm tofu', 'Sweet potato cubes', 'Cauliflower or broccoli', 'Olive oil', 'Balsamic vinegar', 'Maple syrup', 'Garlic'],
    instructions: ['Press tofu and cut into cubes.', 'Toss tofu and vegetables with maple-balsamic sauce.', 'Roast until tofu edges are crisp and sweet potatoes are tender.'],
    tags: ['book-recipe', 'dinner', 'vegetarian'],
  },
  {
    id: 'book-mme-turkey-taco-skillet',
    name: 'Turkey Taco Skillet with Black Beans',
    category: 'Dinner',
    description: 'A one-pan taco skillet built for weeknight speed.',
    servings: 4,
    prep_time: '5 mins',
    cook_time: '15 mins',
    calories: 350,
    protein: 33,
    carbs: 28,
    fat: 10,
    fiber: 8,
    ingredients: ['Lean ground turkey', 'Black beans', 'Diced tomatoes', 'Onion', 'Garlic', 'Taco seasoning', 'Corn', 'Optional Greek yogurt topping'],
    instructions: ['Brown turkey with onion and garlic.', 'Add beans, tomatoes, corn, and taco seasoning.', 'Simmer until thickened and serve as a bowl or lettuce cups.'],
    tags: ['book-recipe', 'dinner', 'one-pan'],
  },
  {
    id: 'book-mme-lemon-garlic-shrimp-orzo',
    name: 'One-Pot Lemon Garlic Shrimp & Orzo',
    category: 'Dinner',
    description: 'A fast one-pot shrimp dinner with bright lemon flavor.',
    servings: 4,
    prep_time: '5 mins',
    cook_time: '15 mins',
    calories: 375,
    protein: 30,
    carbs: 42,
    fat: 8,
    fiber: 4,
    ingredients: ['Shrimp', 'Orzo', 'Broth', 'Frozen peas', 'Garlic', 'Lemon zest and juice', 'Parsley', 'Olive oil'],
    instructions: ['Sear shrimp briefly and set aside.', 'Cook garlic, broth, and orzo in the same pan.', 'Stir in peas, lemon, parsley, and shrimp to warm through.'],
    tags: ['book-recipe', 'dinner', 'one-pot'],
  },
  {
    id: 'book-mme-creamy-tomato-spinach-chickpea-skillet',
    name: 'Creamy Tomato & Spinach Chickpea Skillet',
    category: 'Dinner',
    description: 'A quick vegetarian skillet with chickpeas and spinach.',
    servings: 4,
    prep_time: '5 mins',
    cook_time: '10 mins',
    calories: 310,
    protein: 15,
    carbs: 42,
    fat: 8,
    fiber: 10,
    ingredients: ['Chickpeas', 'Diced tomatoes', 'Spinach', 'Onion', 'Garlic', 'Low-fat milk or almond milk', 'Basil', 'Parmesan or nutritional yeast'],
    instructions: ['Saute onion and garlic.', 'Add chickpeas, tomatoes, milk, and basil, then simmer.', 'Stir in spinach and finish with parmesan or nutritional yeast.'],
    tags: ['book-recipe', 'dinner', 'vegetarian'],
  },
  {
    id: 'book-mme-teriyaki-beef-stir-fry',
    name: 'Teriyaki Beef Stir-Fry',
    category: 'Dinner',
    description: 'A fast beef stir-fry served with rice.',
    servings: 4,
    prep_time: '10 mins',
    cook_time: '10 mins',
    calories: 420,
    protein: 28,
    carbs: 46,
    fat: 12,
    fiber: 4,
    ingredients: ['Lean sliced beef', 'Mixed stir-fry vegetables', 'Cooked rice', 'Low-sodium teriyaki sauce', 'Garlic', 'Ginger', 'Cornstarch slurry'],
    instructions: ['Sear beef quickly and remove from pan.', 'Stir-fry vegetables with garlic and ginger.', 'Return beef and add sauce until glossy. Serve with rice.'],
    tags: ['book-recipe', 'dinner', 'stir-fry'],
  },
  {
    id: 'book-mme-one-pot-turkey-bolognese',
    name: 'One-Pot Turkey Bolognese',
    category: 'Dinner',
    description: 'A macro-friendly pasta dinner made in one pot.',
    servings: 4,
    prep_time: '5 mins',
    cook_time: '25 mins',
    calories: 410,
    protein: 32,
    carbs: 52,
    fat: 9,
    fiber: 8,
    ingredients: ['Lean ground turkey', 'Whole-wheat pasta', 'Crushed tomatoes', 'Onion', 'Garlic', 'Italian seasoning', 'Broth', 'Red pepper flakes'],
    instructions: ['Brown turkey with onion and garlic.', 'Add tomatoes, broth, pasta, and seasoning.', 'Cover and simmer until pasta is tender and sauce thickens.'],
    tags: ['book-recipe', 'dinner', 'one-pot'],
  },
  {
    id: 'book-mme-black-bean-sweet-potato-chili',
    name: 'Simple Black Bean & Sweet Potato Chili',
    category: 'Dinner',
    description: 'A hearty vegetarian chili with high fiber.',
    servings: 6,
    prep_time: '10 mins',
    cook_time: '20 mins',
    calories: 290,
    protein: 14,
    carbs: 48,
    fat: 5,
    fiber: 12,
    ingredients: ['Black beans', 'Sweet potatoes', 'Diced tomatoes', 'Onion', 'Garlic', 'Chili powder', 'Cumin', 'Broth'],
    instructions: ['Saute onion, sweet potato, and garlic.', 'Add spices, beans, tomatoes, and broth.', 'Simmer until sweet potatoes are tender.'],
    tags: ['book-recipe', 'dinner', 'vegetarian', 'high-fiber'],
  },
  {
    id: 'book-mme-turkey-cheese-roll-ups',
    name: 'Turkey & Cheese Roll-Ups',
    category: 'Snack',
    description: 'A no-cook protein snack for the afternoon slump.',
    servings: 1,
    prep_time: '3 mins',
    cook_time: '0 mins',
    calories: 175,
    protein: 22,
    carbs: 2,
    fat: 9,
    fiber: 0,
    ingredients: ['Turkey slices', 'Cheese slice or cheese stick', 'Pickle spear or cucumber', 'Mustard'],
    instructions: ['Spread mustard on turkey slices.', 'Add cheese and pickle or cucumber.', 'Roll tightly and eat immediately or pack chilled.'],
    tags: ['book-recipe', 'snack', 'no-cook', 'high-protein'],
  },
  {
    id: 'book-mme-cottage-cheese-loaded-bowl',
    name: 'Cottage Cheese Loaded Bowl',
    category: 'Snack',
    description: 'A savory high-protein mini-meal.',
    servings: 1,
    prep_time: '5 mins',
    cook_time: '0 mins',
    calories: 195,
    protein: 24,
    carbs: 10,
    fat: 7,
    fiber: 2,
    ingredients: ['1 cup low-fat cottage cheese', 'Cherry tomatoes', 'Cucumber', 'Everything seasoning', 'Chives', 'Cracked pepper'],
    instructions: ['Spoon cottage cheese into a bowl.', 'Top with chopped vegetables and seasoning.', 'Serve cold.'],
    tags: ['book-recipe', 'snack', 'high-protein'],
  },
  {
    id: 'book-mme-spicy-tuna-rice-cakes',
    name: 'Spicy Tuna Rice Cakes',
    category: 'Snack',
    description: 'A crunchy pantry-friendly protein snack.',
    servings: 1,
    prep_time: '3 mins',
    cook_time: '0 mins',
    calories: 210,
    protein: 23,
    carbs: 16,
    fat: 4,
    fiber: 0,
    ingredients: ['1 can tuna', '2 rice cakes', 'Greek yogurt or light mayo', 'Hot sauce', 'Green onion', 'Cucumber slices'],
    instructions: ['Mix tuna with yogurt or mayo and hot sauce.', 'Spoon onto rice cakes.', 'Top with green onion and cucumber.'],
    tags: ['book-recipe', 'snack', 'quick'],
  },
  {
    id: 'book-mme-crispy-roasted-chickpeas',
    name: 'Crispy Roasted Chickpeas',
    category: 'Snack',
    description: 'A batch-friendly crunchy snack.',
    servings: 4,
    prep_time: '5 mins',
    cook_time: '30 mins',
    calories: 130,
    protein: 5,
    carbs: 18,
    fat: 5,
    fiber: 5,
    ingredients: ['1 can chickpeas', 'Olive oil', 'Smoked paprika', 'Garlic powder', 'Salt'],
    instructions: ['Drain, rinse, and dry chickpeas very well.', 'Toss with oil and seasonings.', 'Roast until crisp, shaking the pan halfway through.'],
    tags: ['book-recipe', 'snack', 'batch-prep'],
  },
  {
    id: 'book-mme-protein-balls',
    name: 'Peanut Butter Chocolate Chip Protein Balls',
    category: 'Snack',
    description: 'A sweet make-ahead snack with protein.',
    servings: 1,
    prep_time: '10 mins',
    cook_time: '0 mins',
    calories: 175,
    protein: 9,
    carbs: 20,
    fat: 8,
    fiber: 3,
    ingredients: ['Protein powder', 'Oats', 'Peanut butter', 'Mini chocolate chips', 'Honey or maple syrup', 'Splash of milk if needed'],
    instructions: ['Mix ingredients until a dough forms.', 'Roll into balls.', 'Chill before serving.'],
    tags: ['book-recipe', 'snack', 'make-ahead'],
  },
  {
    id: 'book-mme-frozen-berry-yogurt-bark',
    name: 'Frozen Berry & Yogurt Bark',
    category: 'Snack',
    description: 'A refreshing freezer snack with Greek yogurt.',
    servings: 6,
    prep_time: '5 mins',
    cook_time: '0 mins',
    calories: 100,
    protein: 8,
    carbs: 12,
    fat: 2,
    fiber: 1,
    ingredients: ['2 cups plain non-fat Greek yogurt', 'Mixed berries', 'Honey or maple syrup', 'Chia seeds', 'Vanilla extract'],
    instructions: ['Spread yogurt mixture on a parchment-lined tray.', 'Top with berries and chia seeds.', 'Freeze until firm, then break into pieces.'],
    tags: ['book-recipe', 'snack', 'freezer'],
  },
  {
    id: 'book-mme-protein-mug-cake',
    name: '2-Minute Protein Mug Cake',
    category: 'Dessert',
    description: 'A warm chocolate dessert with a strong protein boost.',
    servings: 1,
    prep_time: '2 mins',
    cook_time: '1 min',
    calories: 180,
    protein: 25,
    carbs: 12,
    fat: 3,
    fiber: 3,
    ingredients: ['1 scoop chocolate protein powder', '1 tsp cocoa powder', '1/4 tsp baking powder', 'Egg white or milk', 'Optional chocolate chips'],
    instructions: ['Stir ingredients in a microwave-safe mug.', 'Microwave until just set.', 'Let cool briefly before eating.'],
    tags: ['book-recipe', 'dessert', 'high-protein'],
  },
];
